import { AxiosRequestConfig } from 'axios';
import keycloak from 'keycloak';

export const authTokenInterceptor = async (
  config: AxiosRequestConfig
): Promise<AxiosRequestConfig> => {
  const token = keycloak.token;

  return {
    ...config,
    headers: { ...config.headers, ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  };
};
